import { render, staticRenderFns } from "./swiper-item-component.vue?vue&type=template&id=871dc600&scoped=true&"
import script from "./swiper-item-component.vue?vue&type=script&lang=js&"
export * from "./swiper-item-component.vue?vue&type=script&lang=js&"
import style0 from "./swiper-item-component.vue?vue&type=style&index=0&id=871dc600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871dc600",
  null
  
)

export default component.exports